//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_DISTRICT_LIST = 'SET_DISTRICT_LIST';
export const CLEAR_DISTRICT_LIST = 'CLEAR_DISTRICT_LIST';
export const DISTRICT_LIST_PENDING = 'DISTRICT_LIST_PENDING';
export const DISTRICT_LIST_ERROR = 'DISTRICT_LIST_ERROR';
export const DISTRICT_LIST_ERROR_CLEAR = 'DISTRICT_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const DISTRICT_FILTER_DIALOG_OPEN = 'DISTRICT_FILTER_DIALOG_OPEN';
export const DISTRICT_FILTER_DIALOG_CLOSE = 'DISTRICT_FILTER_DIALOG_CLOSE';
export const SET_DISTRICT_FILTER_DATA = 'SET_DISTRICT_FILTER_DATA';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const DISTRICT_CREATE_DIALOG_OPEN = 'DISTRICT_CREATE_DIALOG_OPEN';
export const DISTRICT_CREATE_DIALOG_CLOSE = 'DISTRICT_CREATE_DIALOG_CLOSE';
export const DISTRICT_CREATE_PENDING = 'DISTRICT_CREATE_PENDING';
export const DISTRICT_CREATE_ERROR = 'DISTRICT_CREATE_ERROR';
export const DISTRICT_CREATE_ERROR_CLEAR = 'DISTRICT_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const DISTRICT_EDIT_DIALOG_OPEN = 'DISTRICT_EDIT_DIALOG_OPEN';
export const DISTRICT_EDIT_DIALOG_CLOSE = 'DISTRICT_EDIT_DIALOG_CLOSE';
export const DISTRICT_EDIT_PENDING = 'DISTRICT_EDIT_PENDING';
export const DISTRICT_EDIT_ERROR = 'DISTRICT_EDIT_ERROR';
export const DISTRICT_EDIT_ERROR_CLEAR = 'DISTRICT_EDIT_ERROR_CLEAR';